const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  "http://localhost:5000";

function getAuthToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("accessToken")
  );
}

async function request(path, options = {}) {
  const token = getAuthToken();

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {})
    }
  });

  const contentType = response.headers.get("content-type") || "";

  const payload = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    const message =
      payload?.error ||
      payload?.message ||
      (typeof payload === "string" && payload) ||
      `Request failed with status ${response.status}`;

    throw new Error(message);
  }

  return payload;
}

export async function getPrompts() {
  return request("/copilot/prompts", {
    method: "GET"
  });
}

export async function getHistory() {
  return request("/copilot/history", {
    method: "GET"
  });
}

export async function getConversation(conversationId) {
  if (!conversationId) {
    throw new Error("Conversation ID is required.");
  }

  return request(`/copilot/conversations/${conversationId}`, {
    method: "GET"
  });
}

export async function sendMessage({
  message,
  conversationId = null,
  confirmedToolCall = null
}) {
  if (!message || !String(message).trim()) {
    throw new Error("Message is required.");
  }

return request("/copilot/chat", {
  method: "POST",
  body: JSON.stringify({
    message: String(message).trim(),
    conversationId,
    confirmedToolCall
  })
});

}

export async function confirmAction({
  conversationId,
  confirmedToolCall
}) {
  if (!confirmedToolCall) {
    throw new Error("Confirmed tool call is required.");
  }

  return sendMessage({
    message: "__confirm__",
    conversationId,
    confirmedToolCall
  });
}

export async function cancelAction() {
  return {
    cancelled: true
  };
}

export async function clearHistory() {
  return request("/copilot/history", {
    method: "DELETE"
  });
}

const copilotApi = {
  getPrompts,
  getHistory,
  getConversation,
  sendMessage,
  confirmAction,
  cancelAction,
  clearHistory
};

export default copilotApi;